import React from 'react'

const SvgIconCaretDown = (props) => (
  <svg viewBox="0 0 10 5" fill="none" {...props}>
    <path d="M0 0l5 5 5-5H0z" fill="currentColor" />
  </svg>
)

export default SvgIconCaretDown
